if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					const incrementButtons = item.querySelectorAll('.increment-button')
					const addButton = item.querySelector('.add-qty')
					const minusButton = item.querySelector('.minus-qty')
					let currentIncrement = incrementButtons.length ? incrementButtons[0].dataset.increment : '1'
					const inventoryRaw = item.dataset.variantInventoryQty;
					const inventoryQty = inventoryRaw !== undefined && inventoryRaw !== '' ? parseInt(String(inventoryRaw), 10) : null;
					const refreshSelectorState = () => {
						const currentQty = parseInt(qty.value, 10);
						const safeQty = Number.isInteger(currentQty) ? currentQty : 0;
						const remainingForAdds = Number.isInteger(inventoryQty) ? Math.max(0, inventoryQty - safeQty) : null;
						let hasEnabledIncrement = false;
						incrementButtons.forEach((btn) => {
							const inc = parseInt(String(btn.dataset.increment), 10);
							const disabled = Number.isInteger(remainingForAdds) && Number.isInteger(inc) ? inc > remainingForAdds : false;
							btn.classList.toggle('disabled', disabled);
							btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
							btn.setAttribute('tabindex', disabled ? '-1' : '0');
							if (!disabled) {
								hasEnabledIncrement = true;
							}
						});
						const activeButton = item.querySelector('.increment-button.active');
						if (activeButton && activeButton.classList.contains('disabled')) {
							activeButton.classList.remove('active');
							const fallback = Array.from(incrementButtons).find((btn) => !btn.classList.contains('disabled'));
							if (fallback) {
								fallback.classList.add('active');
								currentIncrement = fallback.dataset.increment;
							}
						}
						if (addButton) {
							const selectedInc = parseInt(String(currentIncrement), 10);
							const plusDisabled = !hasEnabledIncrement || (Number.isInteger(remainingForAdds) && Number.isInteger(selectedInc) && selectedInc > remainingForAdds);
							addButton.classList.toggle('disabled', plusDisabled);
							addButton.setAttribute('aria-disabled', plusDisabled ? 'true' : 'false');
						}
					};

					if (incrementButtons.length) {
						incrementButtons[0].classList.add('active')
					}
					refreshSelectorState();

					incrementButtons.forEach((button) => {
						button.addEventListener('click', (e) => {
							if (e.target.classList.contains('disabled')) {
								return;
							}
							incrementButtons.forEach(btn => {
								btn.classList.remove('active')
							})
							e.target.classList.add('active')
							currentIncrement = e.target.dataset.increment
							refreshSelectorState();
						})
					})

					if (addButton) {
						addButton.addEventListener('click', (e) => {
							e.preventDefault()
							if (addButton.classList.contains('disabled')) {
								return;
							}
							const nextQty = parseInt(qty.value, 10) + parseInt(currentIncrement, 10)
							if (!this.validateItemQuantity(item, nextQty, qty)) {
								return;
							}
							qty.value = nextQty
							this.updateCartQty(item, nextQty);
						})
					}

					if (minusButton) {
						minusButton.addEventListener('click', (e) => {
							e.preventDefault()
							let nextQty = parseInt(qty.value, 10) - parseInt(currentIncrement, 10)
							if (nextQty <= 0) {
								nextQty = 0
							}
							if (!this.validateItemQuantity(item, nextQty, qty)) {
								return;
							}
							qty.value = nextQty
							refreshSelectorState();
							this.updateCartQty(item, nextQty);
						})
					}

					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						const nextQty = parseInt(qty.value, 10);
						if (!this.validateItemQuantity(item, nextQty, qty)) {
							const fallbackQty = parseInt(item.dataset.qty || '0', 10);
							qty.value = Number.isInteger(fallbackQty) ? fallbackQty : 0;
							refreshSelectorState();
							return;
						}
						refreshSelectorState();
						this.updateCartQty(item, nextQty);
					}, 500));
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

		_getMaxAllowedQuantityForCartLine(item) {
			const raw = item.dataset.variantInventoryQty;
			if ( raw === undefined || raw === '' ) {
				return null;
			}
			const inventory = parseInt(String(raw), 10);
			if ( ! Number.isInteger(inventory) || inventory < 0 ) {
				return null;
			}
			const variantId = item.dataset.variantId;
			if ( ! variantId ) {
				return inventory;
			}
			let siblingQty = 0;
			this.form.querySelectorAll('[data-js-cart-item]').forEach((el) => {
				if ( el === item ) {
					return;
				}
				if ( String(el.dataset.variantId) !== String(variantId) ) {
					return;
				}
				const q = parseInt(el.dataset.qty || '0', 10);
				if ( Number.isInteger(q) ) {
					siblingQty += q;
				}
			});
			return Math.max(0, inventory - siblingQty);
		}

		validateItemQuantity(item, quantity, qtyInput){
			this.clearItemAlert(item);
			const rules = window.KROWN && window.KROWN.quantityRules ? window.KROWN.quantityRules : null;
			if (!rules) {
				return true;
			}
			const increments = item.dataset.increments || '';
			if (!rules.isValidQuantityForIncrements(quantity, increments)) {
				const alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.dataset.jsQuantityError = 'true';
				alert.innerHTML = rules.getInvalidQuantityMessage(increments);

				const target = item.querySelector('.cart-item__actions') || item.querySelector('.cart-form-item--layout') || this.form;
				target.prepend(alert);

				if (qtyInput) {
					const fallbackQty = parseInt(item.dataset.qty || '0', 10);
					qtyInput.value = Number.isInteger(fallbackQty) ? fallbackQty : 0;
				}

				return false;
			}

			const maxForLine = this._getMaxAllowedQuantityForCartLine(item);
			if (
				maxForLine !== null &&
				!rules.isQuantityWithinAvailableInventory(quantity, maxForLine)
			) {
				const alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.dataset.jsQuantityError = 'true';
				alert.innerHTML = rules.getExceedsInventoryMessage();

				const target = item.querySelector('.cart-item__actions') || item.querySelector('.cart-form-item--layout') || this.form;
				target.prepend(alert);

				if (qtyInput) {
					const fallbackQty = parseInt(item.dataset.qty || '0', 10);
					qtyInput.value = Number.isInteger(fallbackQty) ? fallbackQty : 0;
				}

				return false;
			}

			return true;
		}

		clearItemAlert(item){
			const existingAlert = item.querySelector('[data-js-quantity-error]');
			if (existingAlert) {
				existingAlert.remove();
			}
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			// this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			// this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}